<template>
  <div class="Sanitaire">
    <Back />

    <ProductIntro
      title="Salle de bain et sanitaire"
      image="/images/main/sanitaire-2.jpg"
      icon1="toilet"
      text1="Pose de salle de bain"
      icon2="tools"
      text2="Plomberie sanitaire"
      icon3="clock-fast"
      text3="Dépannage rapide"
    />

    <section class="section">
      <div class="container">
        <ProductParagraph
          title="Nous rénovons et posons votre nouvelle salle de bain"
          text="
          Votre salle de bain est défraichie, ce n’est pas une fatalité ! Nous vous proposons de
          réfléchir ensemble à la meilleur solution pour faire de cette pièce un lieu de détente
          et de sérénité. Une douche à la place d’une baignoire, un nouveau meuble vasque ...
          aucun soucis, notre équipe de poseurs mets tout son savoir faire à votre service."
          conclusion="Votre salle de bain va faire des envieux !"
        />

        <br />
        <Card
          title="Nous installons et dépannons vos chauffe-eau"
          text="
          Fort de notre expérience, nous intervenons sur le remplacement de vos équipements sanitaires (douches, baignoires, lavabos, WC...).
          Nos techniciens et plombiers sont également qualifiés pour le dépannage et la pose de votre chauffe-eau électrique.
          "
          conclusion="A vous les douches biens chaudes !"
          image="/images/secondary/sanitaire.jpg"
        />

        <br />
        <br />

        <ProductParagraph
          title="Vous satisfaire est notre principale préoccupation"
          text="
          C’est pourquoi, nous avons mis en place un service de dépannage rapide.
          Nous intervenons rapidement pour réparer votre chaudière ou chauffe-eau. Soyez tranquille, l’eau chaude et le chauffage seront rétablis au plus vite.
          De même, fini les fuites, nos plombiers experts sont là pour répondre à chaque problématique de tuyauterie. 
          "
          conclusion="Pour vous, on s’occupe de tout !"
        />
      </div>
    </section>
  </div>
</template>

<script>
// Components
import ProductIntro from "@/components/ProductIntro";
import ProductParagraph from "@/components/ProductParagraph";
import Card from "@/components/Card";
import Back from "@/components/Back";

export default {
  name: "Sanitaire",
  components: {
    ProductIntro,
    ProductParagraph,
    Card,
    Back
  }
};
</script>